import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthProvider";
import { useLocationStore } from "../store/location.store";
import {
  detectCommunityOrder,
  CommunityMatch,
} from "../utils/communityDetection";

/**
 * Detects whether the current customer delivery location is inside a
 * Ruchira community (e.g. all Bren Northern Lights flats).
 */
export function useCommunityOrder(): CommunityMatch & { loading: boolean } {
  const { user } = useAuth();
  const coords = useLocationStore((s) => s.coords);
  const label = useLocationStore((s) => s.label);
  const storeIsCommunity = useLocationStore((s) => s.isCommunity);
  const storeCommunityId = useLocationStore((s) => s.communityId);
  const storeCommunityName = useLocationStore((s) => s.communityName);
  const [match, setMatch] = useState<CommunityMatch>({ isCommunity: false });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    // Fast path: location store already tagged this pin as community
    if (storeIsCommunity && storeCommunityId) {
      setMatch({
        isCommunity: true,
        communityId: storeCommunityId,
        communityName: storeCommunityName || undefined,
        reason: "location_store",
      });
      setLoading(false);
      return;
    }

    setLoading(true);
    detectCommunityOrder({
      profile: user,
      address: label || user?.address || user?.homeAddress,
      location: coords,
    }).then((result) => {
      if (!cancelled) {
        setMatch(result);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [
    user?.uid,
    user?.address,
    user?.homeAddress,
    JSON.stringify(user?.homeAddressMeta || null),
    coords?.lat,
    coords?.lng,
    label,
    storeIsCommunity,
    storeCommunityId,
    storeCommunityName,
  ]);

  return { ...match, loading };
}
